import { render, staticRenderFns } from "./MainBase.vue?vue&type=template&id=2ba41752&"
import script from "./MainBase.vue?vue&type=script&lang=js&"
export * from "./MainBase.vue?vue&type=script&lang=js&"
import style0 from "./MainBase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports